import {
  ArrowRight,
  ArrowRightCircle,
  ChartNoAxesCombined,
  ShieldCheck,
  Building2,
} from "lucide-react";

import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { slideLeft } from "../../animations/variants";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { insightCTA, insightData } from "i18n/Insight";

const ListInsight = () => {
  const lang = useSelector((state) => state.language.lang);

  const consults = insightData[lang];
  const cta = insightCTA[lang];

  const icons = [ChartNoAxesCombined, ShieldCheck, Building2];

  // 🎨 Different background style for each section
  const cardStyles = [
    {
      wrapper:
        "bg-gradient-to-br from-red-300 via-white to-rose-200 border-red-500",

      section: "bg-white/80 border-red-100",

      heading: "text-reddark",
    },

    {
      wrapper:
        "bg-gradient-to-br from-amber-50 via-white to-orange-50 border-amber-100",

      section: "bg-white/80 border-amber-100",

      heading: "text-amber-700",
    },

    {
      wrapper:
        "bg-gradient-to-br from-emerald-50 via-white to-green-50 border-emerald-100",

      section: "bg-white/80 border-emerald-100",

      heading: "text-emerald-700",
    },
  ];

  const navigate = useNavigate();

  return (
    <section className="py-20 md:py-20 bg-[#fff] ">
      <div className="grid lg:grid-cols-3 gap-0 ">
        {consults.map((service, index) => {
          const Icon = icons[index];
          const style = cardStyles[index];

          return (
            <motion.div
              key={service.id}
              variants={slideLeft}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className={`
                 my-4
                p-6 md:p-12
                relative
                overflow-hidden
                rounded-[2rem]


              `}
            >
              <div className="absolute top-0 right-0 w-40 h-40 blur-3xl rounded-full" />

              <h3
                className={`
                  flex items-start gap-3
                  text-2xl md:text-3xl
                  font-semibold mb-6
                  font-[Crimson]
                  ${style.heading}
                `}
              >
                <Icon className={`w-7 h-7 shrink-0 ${style.heading}`} />

                {service.title}
              </h3>

              <p className="text-gray-700 text-base md:text-lg mb-8 leading-relaxed">
                {service.description}
              </p>

              {service.sections?.map((section, sectionIndex) => (
                <div
                  key={sectionIndex}
                  className={`
    mb-8
  
  `}
                >
                  <div className="flex items-center justify-between my-5">
                    <span
                      className={`
      inline-flex
      items-center
      px-4 py-2
      rounded-lg
      text-xs
      font-bold
      uppercase
      tracking-wide
      text-white
      ${index === 0 ? "bg-reddark" : index === 1 ? "bg-amber-500" : "bg-emerald-500"}
    `}
                    >
                      {section.country}
                    </span>
                  </div>

                  <div className="grid gap-4">
                    {section.items.map((item, i) => (
                      <div
                        key={i}
                        className={`
                          border rounded-2xl p-5
                          hover:shadow-lg
                          transition-all duration-300
                          backdrop-blur-sm
                          ${style.section}
                            ${style.wrapper}
                        `}
                      >
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`
                            flex items-center gap-2
                            text-lg font-semibold
                            hover:underline
                            ${style.heading}
                          `}
                        >
                          {item.title}

                          <ArrowRight className="w-4 h-4" />
                        </a>

                        <p className="text-gray-700 mt-3 leading-relaxed">
                          {item.description}
                        </p>

                        <div className="mt-8 rounded-2xl overflow-hidden border border-red-100">
                          {item.embed === false ? (
                            <img
                              src={item.image}
                              alt={item.title}
                              className="w-full h-[300px] object-cover     object-top
 rounded-2xl mt-0"
                            />
                          ) : (
                            <iframe
                              src={item.link}
                              title={item.title}
                              className="w-full h-[300px] rounded-2xl mt-0"
                            />
                          )}
                        </div>
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`
                            inline-flex items-center gap-2
                            mt-4 text-sm font-medium
                            hover:underline
                            ${style.heading}
                          `}
                        >
                          {lang === "vi" ? "Truy cập website" : "Visit Website"}

                          <ArrowRightCircle className="w-4 h-4" />
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default ListInsight;
